import { normalizeLandstarProductImageUrl } from "../utils/helpers.js";

function ExistingRedemptionCard({ orderStatus, adminContext = false }) {
  if (!orderStatus) {
    return null;
  }

  const orderedProducts =
    Array.isArray(orderStatus.selectedProducts) && orderStatus.selectedProducts.length
      ? orderStatus.selectedProducts
      : [
          {
            name: orderStatus.selectedProductName,
            sku: orderStatus.selectedSku,
            image: orderStatus.selectedProductImage,
            selectedSize: orderStatus.selectedSize,
            selectedColor: orderStatus.selectedColor,
            personalization: orderStatus.personalization,
          },
        ];

  return (
    <div className="landstar-status-card">
      <p className="landstar-kicker">Existing Redemption</p>
      <p className="landstar-helper-text">
        {adminContext
          ? "This driver code already has an active redemption record. Admin imports remain available, but another redemption cannot be submitted."
          : "This driver code already has an active redemption record, so it can’t be used again."}
      </p>

      {orderedProducts.map((product, index) => {
        const productImage = normalizeLandstarProductImageUrl(product.image || "");

        return (
          <div
            className="landstar-status-product"
            key={`${product.sku || product.name || "reward"}-${index}`}
          >
            {productImage ? (
              <img
                src={productImage}
                alt={product.name || "Landstar reward"}
                className="landstar-status-image"
              />
            ) : null}
            <div>
              <h4>{product.name || "Landstar reward"}</h4>
              {product.sku ? <p className="landstar-helper-text">SKU: {product.sku}</p> : null}
              {product.selectedSize ? (
                <p className="landstar-helper-text">Size: {product.selectedSize}</p>
              ) : null}
              {product.selectedColor ? (
                <p className="landstar-helper-text">Color: {product.selectedColor}</p>
              ) : null}
              {product.personalization ? (
                <p className="landstar-helper-text">
                  Personalization: {product.personalization}
                </p>
              ) : null}
            </div>
          </div>
        );
      })}

      <div className="landstar-status-grid">
        <p>
          <strong>Status:</strong> {orderStatus.stageStatus}
        </p>
        <p>
          <strong>Confirmation:</strong> {orderStatus.submissionId}
        </p>
        {orderStatus.magentoIncrementId ? (
          <p>
            <strong>Order Number:</strong> {orderStatus.magentoIncrementId}
          </p>
        ) : null}
        <p>
          <strong>Submitted:</strong> {new Date(orderStatus.submittedAt).toLocaleString()}
        </p>
      </div>
    </div>
  );
}

export default ExistingRedemptionCard;
